// tslint:disable-next-line: max-line-length
import { DwCoreConfig, DwAuthGuardService, DwConfig, DwUIMetaDataConfigDefaults, DwConfigServiceToken, DwUIConfig, DwAgGridComponent, DwUIMetaDataConfig, DwConfigProviderBase, DwUiConfigName, DwCoreConfigDefaults, DwAttributeType, DwControlType, DwMediaConfigName, DwMediaConfig, DwGridActionLocation, DwGridActionKeys} from '@devwareapps/devware-cap';
import { Config, ConfigService } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@DwConfig()
@Injectable()
export class AppDevwareConfigProvider extends DwConfigProviderBase {
    configureCoreConfig(dwCoreConfig: DwCoreConfig) {
        dwCoreConfig.securityConfig.securityTokenTimeoutMinutes = 5;
        // Configure scopes needed for any MS Graph
        dwCoreConfig.securityConfig.ssoScopes = 'openid, profile, Mail.Send';
        dwCoreConfig.routingConfig.loginRouteUrl = 'login';
        dwCoreConfig.routingConfig.defaultRouteUrl = '/';
        dwCoreConfig.routingConfig.afterLoginRoute = 'home';
        
        dwCoreConfig.baseTitle = ConfigService.config.baseTitle;

        dwCoreConfig.loggingConfig.writeAllToConsole = (ConfigService.config as any).enableConsoleLogging;

        dwCoreConfig.tenantKey = (ConfigService.config as any).tenantKey;

        // Override the default CanActivate guard
        dwCoreConfig.routingConfig.defaultCanActivateGuard = DwAuthGuardService;

        // Add any global settings
        dwCoreConfig.globals.trustBaseUrl = ConfigService.config.trustBaseUrl;
        dwCoreConfig.globals.apiRoot = ConfigService.config.apiRoot;

        // Setup configService.config specific configuration
        dwCoreConfig.apiRoot = ConfigService.config.apiRoot;
        dwCoreConfig.securityConfig.allowAnonymousAccess = false;

        // Allow annonymous access to these paths by skipping the auto sso
        dwCoreConfig.securityConfig.ssoSkipAutoLoginPaths = ['/surveys','/public-boards'];
    }

    configureAdditionalConfig(configName: string, config: any, dwCoreCore: DwCoreConfig) {
        switch (configName) {
            case DwUiConfigName:
                this.configureUIConfig(config);
                break;

            case DwUIMetaDataConfigDefaults.configName:
                this.configureUIMetaDataConfig(config);
                break;

            case DwMediaConfigName:
                this.configureMediaConfig(config);
        }
    }

    private configureUIConfig(dwUiConfig: DwUIConfig) {
        // Setup Contact us menu
        dwUiConfig.showContactUs = ConfigService.config.showContactUs;
        dwUiConfig.contactUsEMail = ConfigService.config.contactUsEmail;

        dwUiConfig.gridComponent = DwAgGridComponent;
        dwUiConfig.pageFooterHeight = 0;
        dwUiConfig.showFooter = false;

        dwUiConfig.allowConfiguration = ConfigService.config.allowConfiguration;

        //dwUiConfig.emailValidationRegEx = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}[ ]*[;,]?[ ]*)+$/;
        dwUiConfig.emailValidationRegEx = /^([ ]*(?<!\.)(?!.*\.\.)[\w+\.\-!#-'\*\/=\?\^`{-}~]+(?!\.)@[a-zA-Z0-9\-\.]+\.[A-Za-z]{2,63}[ ]*[;,]*[ ]*)+$/;

        dwUiConfig.calcDebounceTime = 50;
    }

    private configureUIMetaDataConfig(dwUiMetaDataConfig: DwUIMetaDataConfig) {
        dwUiMetaDataConfig.useGmtDateTime = true;
        dwUiMetaDataConfig.use24HourTime = false;
        dwUiMetaDataConfig.pdfRenderWaitTimeMs = 1200;
        
        dwUiMetaDataConfig.gridDefaultPreferences.rowHeight = 25;

        dwUiMetaDataConfig.userContextExtendedAttributes = [
          { name: 'TrustUserId', display: 'Trust User Id', attrType: DwAttributeType.Integer, controlType: DwControlType.NumericTextBox },
          { name: 'WachterDepartmentId', display: 'Wachter Department Id', attrType: DwAttributeType.Integer, controlType: DwControlType.NumericTextBox },
          { name: 'WachterTeamId', display: 'Wachter Team Id', attrType: DwAttributeType.Integer, controlType: DwControlType.NumericTextBox }
      ];

      // Feature toggle for grid quick search default for any grids that don't have actions configured
      if (ConfigService.config.features?.gridIncludeQuickSearch) {
          dwUiMetaDataConfig.gridButtonDefaults[DwGridActionLocation.actionBarRight] = [ DwGridActionKeys.gridQuickSearch ,DwGridActionKeys.gridFilterToggle, DwGridActionKeys.gridRefresh, DwGridActionKeys.gridExport ];
      } else {
        dwUiMetaDataConfig.gridButtonDefaults[DwGridActionLocation.actionBarRight] = [ DwGridActionKeys.gridFilterToggle, DwGridActionKeys.gridRefresh, DwGridActionKeys.gridExport ];
      }
      
    }


    
    configureMediaConfig(mediaConfig: DwMediaConfig) {
        mediaConfig.defaultMaxFileSizeMb = 50;
 
        // Code from Trust listing default allowed file types
        //        return [".doc", ".pdf", ".txt", ".jpg", ".gif", ".xls", ".xlsx", ".docx", ".odt", ".rtf", ".csv", ".cad", ".est", ".html", ".htm", ".mdi", ".msg", ".ppt", ".rar", ".zip", ".vsd", ".bmp", ".png", ".tif", ".tiff", ".xlsm", ".pptx", ".dwf", ".dwg", ".ciq", ".flw", ".xml", ".dwfx", ".jpeg", ".oft", ".dotx", ".ppsx", ".xslt", ".mp4", ".es10", ".vsdx", ".es13"];
        mediaConfig.defaultFileTypes = 'doc,pdf,txt,jpg,gif,xls,xlsx,docx,odt,rtf,csv,cad,est,html,htm,mdi,msg,ppt,rar,zip,vsd,bmp,png,tif,tiff,xlsm,pptx,dwf,dwg,ciq,flw,xml,dwfx,jpeg,oft,dotx,ppsx,xslt,mp4,es10,vsdx,es13';
    }

}